import { useState } from 'react';
import { IVariant } from 'base/interfaces/product';
import { useTrans } from 'base/utils/i18n';
import { IconShipped } from '@base/icon/IconShipped';
import { IconWarranty } from '@base/icon/IconWarranty';
import { IconReturn } from '@base/icon/IconReturn';
import { IconHelp } from '@base/icon/IconHelp';
import Image from '@base/lib/ThemeImage'
import { replacePlaceholderWithComponent } from 'base/utils/string'

type IProdTip = {
    icon: React.ReactNode;
    title: React.ReactNode;
    description?: React.ReactNode;
};

type IProdTipsRes = {
    list: IProdTip[];
    returnPolicyVisible: boolean;
    closeReturnPolicy: () => void;
};

export function useProdTips(variant: IVariant): IProdTipsRes {
    const { t } = useTrans();
    const [returnPolicyVisible, setReturnPolicyVisible] = useState<boolean>(false);

    // debug
    // variant.warrantyAfterSaleTime = '1 year';
    // variant.warrantyFreeReturnTime = '7 days';

    const list: IProdTip[] = [
        {
            icon: <IconShipped/>,
            title: t('web_product_tips_free_shipping', { ammount: variant.freeShipOrderAmount || '$59' }),
            description: !!variant.seelWfdTip ? (
                <div className={'flex flex-middle'}>
                    {replacePlaceholderWithComponent(
                        variant.seelWfdTip || 'Worry-Free Return & Delivery available with {{logo}}',
                        {
                            logo: (
                                <>
                                    &nbsp;
                                    <Image
                                        src="asset/width-120/picture/d2f819c0cccc0a5bf38ab1277af38fa5.png"
                                        width={30}
                                        height={16}
                                        fixed
                                        background={false}
                                    />
                                </>
                            )
                        }
                    )}
                </div>
            ) : void 0
        }
    ];
    if (variant.warrantyAfterSaleTime) {
        list.push({
            icon: <IconWarranty/>,
            title: t('web_product_tips_warranty'),
            description: variant.warrantyAfterSaleTime
        })
    }
    if (variant.warrantyFreeReturnTime) {
        list.push({
            icon: <IconReturn/>,
            title: t('web_product_tips_returns'),
            description: (
                <>
                    {variant.warrantyFreeReturnTime}
                    <IconHelp
                        className={'g-icon-help'}
                        onClick={() => setReturnPolicyVisible(true)}
                    />
                </>
            )
        })
    }
    return {
        list,
        returnPolicyVisible,
        closeReturnPolicy: () => setReturnPolicyVisible(false)
    }
}